import React from 'react'

const Created = props => (
  <svg
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    viewBox='0 0 16 16'
    fill={props.color ? props.color : '#FFFFFF'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M7.99994 2.0001C4.34069 2.0001 1.24994 5.09085 1.24994 8.7501C1.24994 12.4094 4.34069 15.5001 7.99994 15.5001C11.6592 15.5001 14.7499 12.4094 14.7499 8.7501C14.7499 5.09085 11.6592 2.0001 7.99994 2.0001ZM7.99994 14.0001C5.15444 14.0001 2.74994 11.5956 2.74994 8.7501C2.74994 5.9046 5.15444 3.5001 7.99994 3.5001C10.8454 3.5001 13.2499 5.9046 13.2499 8.7501C13.2499 11.5956 10.8454 14.0001 7.99994 14.0001Z' />
    <path d='M8.74994 5.0001H7.24994V8.0001H4.24994V9.5001H7.24994V12.5001H8.74994V9.5001H11.7499V8.0001H8.74994V5.0001Z' />
    <path d='M14.2192 4.03088L11.9617 1.78064L13.0206 0.718262L15.2782 2.9685L14.2192 4.03088Z' />
    <path d='M2.96176 0.720697L4.02392 1.77986L1.78115 4.02898L0.718994 2.96982L2.96176 0.720697Z' />
  </svg>
)

export default Created
